import * as React from "react";
import styled, { css } from "styled-components";
import { Field } from "formik";
import AbsoluteDateInput from "./AbsoluteDateInput";
const ErrorMessage = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.dark.danger};
    font-size: ${theme.fonts.size.small};
    font-style: italic;
    padding: 3px 3px 9px;
    height: 1.5em;
  `
);
const AbsoluteTimestamp = ({ disabled = false, timeRange, range, label }) => /* @__PURE__ */ React.createElement(Field, { name: `timeRangeTabs.absolute.${range}` }, ({ field: { value, onChange, name }, meta: { error } }) => {
  const _onChange = (newValue) => onChange({ target: { name, value: newValue } });
  const dateTime = error ? timeRange[range] : value || timeRange[range];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AbsoluteDateInput, { name, disabled, value: dateTime, onChange: _onChange, label }), /* @__PURE__ */ React.createElement(ErrorMessage, null, error));
});
export default AbsoluteTimestamp;
